import React, { useState, useEffect } from "react";

import {
  Table,
  Card,
  CardBody,
  Collapse,
  Button,
  CardTitle,
  Row,
} from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";

//redux
import { connect } from "react-redux";

import { useLocation } from "react-router-dom";

//paginação
import Pagination from "../../../components/Paginationv3";

//componentes
import ModalNewGroup from "./modalNewGroup";
import ModalEdidGroup from "./modalEditGroup";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ModalAllImports from "./imports/ModalAllImports";
import WaitExport from "../../../components/WaitExport";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
//services e utils
import {
  getGroups,
  deleteGroup,
  deleteAllGroups,
} from "../../../utils/services/group";
import { getGroupsInNotificationsNotSended } from "../../../utils/services/notification";
import { disableScheduleByGroup } from "../../../utils/services/schedule";
import useDebounce from "../../../utils/hooks/useDebounce";
import { formatData } from "../../../utils/helpers/files/formatDate";
import { createXlsx } from "./createXlsx";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";

function Group(props) {
  const location = useLocation();
  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewGroup, setModalNewGroup] = useState(false);
  const [modalEditGroup, setModalEditGroup] = useState(false);
  const [modalAllImports, setModalAllImports] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  //deletar grupo
  const [groupDelete, setGroupDelete] = useState();
  const [confirm_alert, setconfirm_alert] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [dynamic_title, setdynamic_title] = useState("");
  const [dynamic_description, setdynamic_description] = useState("");
  //editar grupo
  const [groupEdit, setGroupEdit] = useState();
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  //state de feed
  const [groups, setGroups] = useState([]);
  // quantidade de itens por pagina
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [dataErrorNotifications, setDataErrorNotifications] = useState([]);
  const [errorAlert, setErrorAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  // collapse
  const [isCollapse, setIsCollapse] = useState(false);
  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  //estado com a quantidade total de items na API
  const [countData, setCountData] = useState(0);
  const debouncedSearch = useDebounce(search, 300);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  // state de carregamento da tabela
  const [loading, setLoading] = useState(false);
  // id do evento
  const idEvent = location.state.idEvent;

  function toggleNewGroup() {
    setModalNewGroup(!modalNewGroup);
  }

  function toggleEditGroup() {
    setModalEditGroup(!modalEditGroup);
  }

  async function handleConfirmAlert(e) {
    const event = idEvent;
    const group = e.id;
    const token = props.state.global_user_data.data.token;
    setErrorAlert(false);
    const resultGroup = await getGroupsInNotificationsNotSended(
      event,
      group,
      token,
    );
    if (resultGroup.data.length > 0) {
      setDataErrorNotifications(resultGroup.data);
      setconfirm_alert(false);
      setErrorAlert(true);
      return;
    }
    setconfirm_alert(true);
  }

  async function deleGroupFunc() {
    await deleteGroup({
      id: groupDelete.id,
      jwt: props.state.global_user_data.data.token,
    })
      .then(async (res) => {
        if (res.message === "DELETED_GROUP") {
          getGroupsFunc();
          setconfirm_alert(false);
          setsuccess_dlg(true);
          setdynamic_title("Sucesso");
          setdynamic_description("Grupo deletado com sucesso");
          try {
            await disableScheduleByGroup({
              jwt: props.state.global_user_data.data.token,
              groupId: groupDelete.id,
            });
          } catch (error) {
            // console.log(error);
          }
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  async function deleteAllGroupsFunc() {
    try {
      const res = await deleteAllGroups({ idEvent });

      console.log("ok", res);

      if (res.message === "DISABLE_ALL_GROUPS") {
        setsuccess_dlg(true);
        setdynamic_title("Sucesso");
        setdynamic_description("Grupos deletados com sucesso");
      }
    } catch (error) {
      console.log();
    }
  }

  async function getGroupsFunc() {
    setLoading(true);
    await getGroups({
      jwt: props.state.global_user_data.data.token,
      eventId: idEvent,
      offset: currentIndex > 0 ? currentIndex : 1,
      limit: itemsPerPage,
      search: debouncedSearch,
    })
      .then((response) => {
        setGroups(response.findOneGroupData.data);
        setCountData(response.findOneGroupData.count);
      })
      .catch((error) => {
        // console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  async function exportData() {
    createXlsx({
      idEvent: idEvent,
      limit: 100,
      countData,
      setFinishExport,
    }) > setExportInProgress(true);
  }

  useEffect(() => {
    getGroupsFunc();
  }, [currentIndex, itemsPerPage, debouncedSearch]);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Grupos"
          onConfirm={deleteAllGroupsFunc}
        />
      )}

      {modalNewGroup && (
        <ModalNewGroup
          isOpen={modalNewGroup}
          toggle={toggleNewGroup}
          idEvent={idEvent}
          getGroupsFunc={getGroupsFunc}
        />
      )}

      {modalEditGroup && (
        <ModalEdidGroup
          isOpen={modalEditGroup}
          toggle={toggleEditGroup}
          getGroupsFunc={getGroupsFunc}
          group={groupEdit}
        />
      )}

      {modalAllImports && (
        <ModalAllImports
          isOpen={modalAllImports}
          toggle={() => setModalAllImports(false)}
          idEvent={idEvent}
          getGroupsFunc={getGroupsFunc}
        />
      )}

      {confirm_alert ? (
        <SweetAlert
          title={`Deseja deletar ${groupDelete ? groupDelete.name : ""}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            deleGroupFunc();
          }}
          onCancel={() => setconfirm_alert(false)}
        >
          <a>Você não poderá reverter essa ação!</a>
        </SweetAlert>
      ) : errorAlert ? (
        <SweetAlert
          title={`Não foi possível excluir o grupo: ${groupDelete.name}`}
          error
          showCancel
          cancelBtnText="Fechar"
          showConfirm={false}
          cancelBtnBsStyle="danger"
          onCancel={() => {
            setIsOpen(false);
            setErrorAlert(false);
          }}
        >
          <span>
            Existem notificações agendadas para esse grupo que ainda não foram
            enviadas.
          </span>
          {!isOpen && (
            <div
              className="sw-error-icon-collpase"
              onClick={() => setIsOpen(!isOpen)}
            >
              <i className={"mdi mdi-arrow-collapse-down"} />
            </div>
          )}
          <Collapse isOpen={isOpen}>
            <Card className="sw-error-card">
              <CardBody className="sw-card-body">
                <CardTitle>Notificações agendadas:</CardTitle>
                <Table size="sm">
                  <thead>
                    <tr>
                      <th>Título</th>
                      <th>Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataErrorNotifications.map((e) => (
                      <tr key={e.id}>
                        <td>{e.title}</td>
                        <td>{formatData(e.date)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
            {isOpen && (
              <div className="sw-error-icon-collpase">
                <i
                  className={"mdi mdi-arrow-collapse-up"}
                  onClick={() => setIsOpen(!isOpen)}
                />
              </div>
            )}
          </Collapse>
        </SweetAlert>
      ) : null}

      {success_dlg ? (
        <SweetAlert
          success
          title={dynamic_title}
          onConfirm={() => {
            setsuccess_dlg(false);
            getGroupsFunc();
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}

      {exportInProgress && (
        <WaitExport
          isOpen={exportInProgress}
          name="Grupos"
          preposicao="dos"
          finishExport={finishExport}
          setFinishExport={setFinishExport}
          setExportInProgress={setExportInProgress}
        />
      )}

      <Card>
        <CardBody>
          <CardTitle>Grupos</CardTitle>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsCollapse}
                isOpen={isCollapse}
              />
              <Collapse isOpen={isCollapse}>
                {groups && groups.length > 0 && (
                  <Row className="mobile-btns-top">
                    <div onClick={() => exportData()}>Exportar Grupos</div>
                  </Row>
                )}

                <ActionButtonRounded
                  title="Importar Grupos"
                  onClick={() => setModalAllImports(true)}
                  type="mobile"
                />

                <ActionButtonRounded
                  title="Adicionar Grupo"
                  onClick={() => setModalNewGroup(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              {groups && groups.length > 0 && (
                <Button
                  color="success"
                  onClick={() => exportData()}
                  className="btn-rounded waves-effect waves-light events-button-add"
                >
                  Exportar Grupos
                </Button>
              )}

              <ActionButtonRounded
                title="Importar Grupos"
                onClick={() => setModalAllImports(true)}
                margin={"0 5px"}
              />

              <ActionButtonRounded
                title="Adicionar Grupo"
                onClick={() => setModalNewGroup(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Descrição</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={2} />
                ) : (
                  groups
                    ?.filter(
                      (e) => e.name?.toLocaleLowerCase(),
                      // ?.indexOf(search.toLocaleLowerCase()) > -1
                    )
                    .map((e, i) => (
                      <tr key={i}>
                        <td>{e.name}</td>
                        <td>
                          <i
                            className="mdi mdi-pencil"
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setGroupEdit(e);
                              setModalEditGroup(true);
                            }}
                          />{" "}
                          {/* <i
                            className="mdi mdi-trash-can"
                            style={{
                              color: "red",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setGroupDelete(e);
                              handleConfirmAlert(e);
                            }}
                          /> */}
                          <DeleteButton
                            onClick={() => {
                              setconfirm_alert(true);
                              setGroupDelete(e);
                              handleConfirmAlert(e);
                            }}
                            color="red"
                            fontSize={17}
                          />
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            groups?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {groups?.length > 0 && (
          <ActionButtonRounded
            title="Limpar Todos Grupos"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
            onClick={() => setModalDeleteAll(true)}
          />
        )}
        <Pagination
          data={groups}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          countData={countData}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Group);
